@if (single()) {
  <assist-combobox
    [data]="data()"
    [filterable]="true"
    [value]="value()"
    [valuePrimitive]="false"
    textField="value"
    valueField="value"
    (valueChange)="onValueChange($event)"
    (filterChange)="onFilterChange($event)"
    [allowCustom]="false"
    [valueNormalizer]="valueNormalizer.bind(this)"
    placeholder="Anderson, john.anderson@gmail.com,  John Ande,..."
    [popupSettings]="{
      appendTo: 'component',
      popupClass: '.zfix',
    }"
  >
    <ng-template itemTemplate let-dataItem>
      <assist-attendees-dropdown-item
        [ignoreTimes]="true"
        [from]="from()"
        [to]="to()"
        [lowerBound]="lowerBound()"
        [upperBound]="upperBound()"
        [name]="dataItem.text"
        [email]="dataItem.value"
      />
    </ng-template>

    <ng-template noDataTemplate>
      {{ translation.dropdowns.attendeesHint | transloco }}
    </ng-template>
  </assist-combobox>
}

@if (!single()) {
  <assist-multiselect
    #list
    [data]="data()"
    (filterChange)="onFilterChange($event)"
    [filterable]="true"
    (valueChange)="onValueChange($event)"
    [value]="value()"
    textField="text"
    valueField="value"
    [allowCustom]="true"
    [valueNormalizer]="normalizer"
    placeholder="Anderson, john.anderson@gmail.com,  John Ande,..."
    [popupSettings]="{
      appendTo: 'component',
      popupClass: '.zfix',
    }"
  >
    <ng-template tagTemplate let-dataItem>
      <assist-attendees-dropdown-item
        [ignoreTimes]="ignoreTimes()"
        [from]="from()"
        [to]="to()"
        [lowerBound]="lowerBound()"
        [upperBound]="upperBound()"
        [name]="dataItem.text"
        [email]="dataItem.value"
      />
    </ng-template>
    <ng-template itemTemplate let-dataItem>
      @if (!dataItem.isGroup) {
        <span class="initials" [ngStyle]="{ 'background-color': dataItem.color }">{{ dataItem.initials }}</span>

        {{ dataItem.text }} <{{ dataItem.value }}>
      }
      @if (dataItem.isGroup) {
        <b>{{ dataItem.text }}</b>
      }
    </ng-template>
    <ng-template noDataTemplate>
      {{ translation.dropdowns.attendeesHint | transloco }}
    </ng-template>
  </assist-multiselect>
}
